export default __webpack_public_path__ + "static/logo-color-green-7ae49e9c0afafa1c77e6211ae13ad049.svg";